import Typed from "../components/Typed"
import Project from "../components/Project"
import SectionHeader from "../components/SectionHeader"

export default function Exp(){
    return (
        <div className = "flex flex-col items-center w-full py-16">

            <SectionHeader title = "My Experience" />

            <div className = "w-11/12 max-w-4xl mx-auto">

                <Typed text = {`Education & certifications`}
                    classList = "text-4xl font-bold text-left pt-10 pb-4"
                    delay = {500}
                ></Typed>

                <div className = "flex flex-col max-w-3xl mr-auto">

                    <Project
                        big
                        icon = "cap"
                        iconBg = "#e21833"
                        logo = "/job-logos/umd.svg"
                        company = "University of Maryland, College Park"
                        name = "B.S. Computer Science, Minor in Statistics"
                        tagline = "Class of May 2028"
                        description = {[`- Pursuing a B.S. in Computer Science with a minor in Statistics, graduating May 2028`,

                                `- Coursework: Object Oriented Programming I/II, Algorithms I/II, Computer Systems, Artificial Intelligence, Data Science, Applied Statistics I/II`,
                            ]}
                    ></Project>

                    <Project
                        big
                        icon = "badge"
                        iconBg = "#ff9900"
                        iconColor = "#141414"
                        logo = "/job-logos/aws.svg"
                        company = "AWS Certified Developer - Associate"
                        name = "Amazon Web Services"
                        tagline = "Nov 24 - Nov 27"
                        tech = {["AWS", "Lambda", "DynamoDB", "IAM", "CloudFormation", "CloudWatch"]}
                        description = {[`- Certified by Amazon Web Services in November 2024, valid through November 2027`,

                                `- Covers developing, deploying, and debugging cloud-native applications on AWS, spanning core compute and storage services, IAM security, and CloudWatch-based monitoring`,
                            ]}
                        site = "https://www.credly.com/badges/d2406a97-d937-47de-823b-724981159d3b/public_url"
                    ></Project>

                </div>

                <Typed text = {`Work experience`}
                    classList = "text-4xl font-bold text-left pt-10 pb-4"
                    delay = {500}
                ></Typed>

                <div className = "flex flex-col max-w-3xl mr-auto">

                    <Project
                        big
                        icon = "cloud"
                        iconBg = "#000000"
                        iconColor = "#ff9900"
                        iconOutline
                        logo = "/job-logos/aws.svg"
                        company = "Amazon Web Services"
                        name = "Software Development Engineer Intern"
                        tagline = "Sep 26 - Dec 26"
                        tech = {["AWS", "Redshift"]}
                        description = {[`- Software development intern on the AWS Database Redshift platform`,
                            ]}
                    ></Project>

                    <Project
                        big
                        icon = "card"
                        iconBg = "#004977"
                        logo = "/job-logos/capitalone.svg"
                        company = "Capital One"
                        name = "Software Engineering Intern"
                        tagline = "June 26 - August 26"
                        tech = {["React.js", "Electron", "React-Flow", "TypeScript", "Jest", "Python", "SQLAlchemy", "PostgreSQL", "Redis", "Node.js", "CloudWatch", "OpenSearch", "Claude"]}
                        description = {[`- Overhauled the legacy UI of a test data workflow creator using React.js + Electron with TypeScript-aided workflow and state validation backed by Jest testing on mock workflows, improving editor fluidity via React-Flow and receiving an internal satisfaction report of 90% compared to the legacy tool`,

                                `- Engineered a lightweight tree-style workflow search index to minimize database queries under access constraints, implementing a Python + SQLAlchemy pipeline that distilled popular workflows from a 270,000+ entry PostgreSQL table into a precomputed search index, backed by Redis caching for full workflow retrieval and abstraction through a Node.js IPC module`,

                                `- Developed a Claude skill for workflow generation, constraining open-ended model search via sub-skill decomposition and Python functions for workflow search and validation, using AWS CloudWatch + OpenSearch latency logging to locate bottlenecks and cutting generation time 65% from previous tooling to under 15 seconds`,
                            ]}
                    ></Project>

                    <Project
                        big
                        icon = "box"
                        iconBg = "#ff9900"
                        iconColor = "#141414"
                        logo = "/job-logos/amazon.svg"
                        company = "Amazon (via UMD App Dev Contracting)"
                        name = "Software Engineer (Contract)"
                        tagline = "Jan 26 - Present"
                        tech = {["Docker", "AWS Fargate", "GitHub Actions", "AWS CDK", "TypeScript", "Kinesis", "Lambda", "API Gateway", "Python", "AWS Bedrock", "EventBridge", "CloudWatch", "X-Ray", "SNS"]}
                        description = {[`- Deployed an Amazon Leo space topic research utility adopted into Leo's ecosystem through Docker + AWS Fargate orchestration and GitHub Actions CI/CD, with infrastructure defined in AWS CDK (TypeScript) to allow contribution from non-familiar engineers`,

                                `- Achieved a 34% speedup on a pipeline routing 6,000+ scraped research documents for inference by implementing Kinesis streams feeding Lambda processors handling data processing and redirection, with Lambda + API Gateway fronting for application integration`,

                                `- Integrated automated fine-tuning of an AWS Bedrock source relevancy inference model through AWS EventBridge cron triggers with decision gates to avoid redundant retraining, with CloudWatch + X-Ray application tracing for automated performance monitoring and metric-based SNS notifications to engineers on application failure`,
                            ]}
                        media = {[
                            {
                                type: "deck",
                                src: "/project-media/amazon/adc-amazon-demo-spring-2026.pdf",
                                thumb: "/project-media/amazon/slides/01.jpg",
                                pages: [
                                    "/project-media/amazon/slides/01.jpg",
                                    "/project-media/amazon/slides/02.jpg",
                                    "/project-media/amazon/slides/03.jpg",
                                    "/project-media/amazon/slides/04.jpg",
                                    "/project-media/amazon/slides/05.jpg",
                                    "/project-media/amazon/slides/06.jpg",
                                    "/project-media/amazon/slides/07.jpg",
                                    "/project-media/amazon/slides/08.jpg",
                                    "/project-media/amazon/slides/09.jpg",
                                    "/project-media/amazon/slides/10.jpg",
                                    "/project-media/amazon/slides/11.jpg",
                                    "/project-media/amazon/slides/12.jpg",
                                    "/project-media/amazon/slides/13.jpg",
                                    "/project-media/amazon/slides/14.jpg",
                                    "/project-media/amazon/slides/15.jpg",
                                    "/project-media/amazon/slides/16.jpg",
                                    "/project-media/amazon/slides/17.jpg",
                                    "/project-media/amazon/slides/18.jpg",
                                    "/project-media/amazon/slides/19.jpg",
                                    "/project-media/amazon/slides/20.jpg",
                                    "/project-media/amazon/slides/21.jpg",
                                    "/project-media/amazon/slides/22.jpg",
                                ],
                            },
                        ]}
                    ></Project>

                    <Project
                        big
                        icon = "brain"
                        iconBg = "#e21833"
                        logo = "/job-logos/umd.svg"
                        company = "UMD / UMIACS (Dr. Furong's Lab)"
                        name = "Machine Learning Research Intern"
                        tagline = "Dec 25 - Present"
                        tech = {["Python", "PyTorch", "AnyGrasp", "Open3D", "Qwen3-VL-8B", "Docker", "UV", "psutil", "Pytest"]}
                        description = {[`- Developing automated training for PhysTwin, a physics-based digital twin, with a PhD research team targeting an ICLR submission`,

                                `- Built a Python pipeline linking AnyGrasp multi-camera grasp candidates to Open3D-rendered overlay views consumed by a Qwen3-VL-8B-Instruct-FP8 VLM, enabling researchers to develop changes faster through isolating scene components`,

                                `- Cut research-environment setup time 30% via UV dependency pinning and Docker for ensuring identical setup, with psutil-based timing and memory monitoring across runtime and Pytest unit testing for quickly identifying bottlenecks`,
                            ]}
                    ></Project>

                    <Project
                        big
                        icon = "shell"
                        iconBg = "#c8102e"
                        iconColor = "#ffd200"
                        company = "TerpLabs"
                        name = "Co-Founder, Software Engineer"
                        tagline = "June 25 - Present"
                        tech = {["Jira", "GitHub", "Prisma", "SQL", "Redis", "GPT-4o mini", "ChromaDB", "SentenceBERT"]}
                        description = {[`- Co-founded and scaled a 110+ member campus product studio shipping 5 live products, utilizing Jira task management and GitHub code management to organize teams through agile practices`,

                                `- Sustained 20,000+ site visits within the initial 30-day launch period of Tortuga, an enhanced class scheduler, through developing Prisma-based SQL querying with Redis query caching to reduce database load and application latency`,

                                `- Building a work-in-progress integration of a RAG meal suggestion into the official UMD app using GPT-4o mini over ChromaDB + SentenceBERT vector search on scraped recipe data, achieving 93% generated meal satisfaction on internal test users`,
                            ]}
                        site = "https://tortugasoc.com"
                        media = {["/project-media/tortuga/preview.png"]}
                    ></Project>

                    <Project
                        big
                        icon = "shoe"
                        iconBg = "#f5ecd7"
                        iconColor = "#1d4ed8"
                        company = "Narb"
                        name = "Software Development Intern"
                        tagline = "June 25 - August 25"
                        tech = {["PyTorch", "CLIP", "YOLO", "Flask", "NumPy", "Albumentations", "AWS SageMaker", "CloudWatch"]}
                        description = {[`- Led a startup team on creating a shoe collector's app with utilities for all sneakerheads`,

                                `- Fine-tuned a PyTorch CLIP + YOLO pipeline for shoe classification in the wild, achieving a ~82% real-time accuracy during beta testing`,

                                `- Developed Flask REST API endpoints for retrieving and processing images with NumPy + Albumentations for accelerated model training`,

                                `- Orchestrated SageMaker hosting of real-time inference models during beta deployment with CloudWatch monitoring for emphasis on cost optimization and model drift detection while supporting 50+ beta users`,
                            ]}
                    ></Project>

                    <Project
                        big
                        icon = "turbine"
                        iconBg = "#e21833"
                        logo = "/job-logos/umd.svg"
                        company = "University of Maryland"
                        name = "Machine Learning Research Assistant"
                        tagline = "Feb 25 - Present"
                        tech = {["PyTorch", "LSTM", "ESP32", "Flask", "Mapbox (C#)", "Raspberry Pi"]}
                        description = {[`- Evaluated attention enhancements for an LSTM-based wind speed forecaster in PyTorch for locating optimal wind turbine setups for battery charging with a speed-performance balance, achieving ~2 MPH accuracy improvement`,

                                `- Collaborated with a cross-functional engineering team to develop an optimized data ingestion pipeline for communicating ESP32-read signal data onto Flask data analysis servers to streamline model evaluation`,

                                `- Formulated and developed an interactive AR presentation experience using Mapbox (C#) that accumulates and presents model output on optimal charging setups`,

                                `- Aided in the optimization of a PWM battery charging module to be able to charge multiple batteries efficiently while sending data to our Raspberry Pi server setup`,
                            ]}
                    ></Project>

                    <Project
                        big
                        icon = "drone"
                        iconBg = "#2b3790"
                        logo = "/job-logos/northropgrumman.svg"
                        company = "Northrop-Grumman Innovation Lab"
                        name = "Robotics Researcher"
                        tagline = "Jan 25 - Jul 25"
                        tech = {["Python", "OpenCV", "QGroundControl", "C++", "Arduino", "PCB Design"]}
                        description = {[`- Implemented a Python OpenCV algorithm to detect ocean mines using a drone with >70% accuracy`,

                                `- Utilized QGroundControl alongside custom C++ scripts for intelligent drone maneuvering`,

                                `- Optimized the sensor layout on a PCB to reduce latency taking multiple inputs from Arduinos attached to our drone`,
                            ]}
                    ></Project>

                    <Project
                        big
                        icon = "leaf"
                        iconBg = "#e21833"
                        logo = "/job-logos/umd.svg"
                        company = "University of Maryland"
                        name = "Sustainability Analytics Researcher"
                        tagline = "Jan 25 - December 25"
                        tech = {["R", "Regression Analysis"]}
                        description = {[`- Analyzed datasets regarding the adaptation of "smart-city" utilities in the Baltimore area`,

                                `- Utilized R to find trends and evaluated performance of a regression model to understand the feasibility of smart-city tools`,

                                `- Created an organized research poster presenting the findings and further steps to be taken`,
                            ]}
                    ></Project>

                </div>

                <Typed text = {`Projects`}
                    classList = "text-4xl font-bold text-right pt-20 pb-4"
                    delay = {500}
                ></Typed>

                <div className = "flex flex-col max-w-3xl ml-auto">

                    <Project
                        align = "right"
                        icon = "book"
                        iconBg = "#0f766e"
                        name = "IEX Matching Engine Simulation"
                        tagline = "Order book simulation | July 26 - Aug 26"
                        tech = {["C++", "STL", "POSIX", "LFU caching", "Adaptive LSM", "B+ tree", "rdtscp", "perf"]}
                        description = {[`- Implemented a C++-based order book simulation on historical IEX data, with a contract-based plug-and-play design to allow for evaluating multiple approaches with enforced correctness`,

                                `- Wrote and evaluated paginated hash-based data storage for live order book data with in-memory LFU caching for frequently requested tickers during simulation, evaluated for drift against IEX's historical book data`,

                                `- Designed and assessed the performance of a time-based Adaptive LSM storage against a B+ tree storage for logs during simulation, testing for throughput and latency via rdtscp-based timing and hardware utilization via Linux's perf performance counters`,
                            ]}
                        github = "https://github.com/AmarDhillon05/order-book-playground"
                    ></Project>

                    <Project
                        align = "right"
                        icon = "note"
                        iconBg = "#8b5a2b"
                        name = "Timber"
                        tagline = "Multi-track audio/video editor | June 26 - In Development"
                        tech = {["React Native (Expo)", "TypeScript", "FastAPI", "PyTorch", "HuggingFace", "Electron", "AST / BEATs / CLAP"]}
                        description = {[`- Building a multi-track audio/video editor that runs from a single codebase as a web app, an Electron desktop app, and on iOS via React Native (Expo)`,

                                `- Applies per-track "Blanket" perceptual audio controls, with an AI suggestions feature that recommends Blanket amounts for each track`,

                                `- Suggestions come from a local FastAPI inference service that listens to the audio using AST / BEATs / CLAP models rather than a hosted LLM`,
                            ]}
                        github = "https://github.com/AmarDhillon05/Timber"
                    ></Project>

                    <Project
                        align = "right"
                        icon = "chart"
                        iconBg = "#16a34a"
                        name = "Re.Sell"
                        tagline = "Sneaker resale analytics tool | May 26 - In Development"
                        tech = {["C++", "CUDA", "SQLite", "KicksDB API", "Make"]}
                        description = {[`- Building a C++ sneaker resale analytics tool that pulls live shoe market data from the KicksDB API into a local SQLite database`,

                                `- Fitting CUDA-accelerated Hamiltonian Monte Carlo models to estimate resale price distributions and their uncertainty`,

                                `- Includes plotting utilities and dotenv-based configuration for a self-contained command-line workflow`,
                            ]}
                        github = "https://github.com/AmarDhillon05/Re.Sell"
                    ></Project>

                    <Project
                        align = "right"
                        icon = "grip"
                        iconBg = "#0891b2"
                        name = "Grasp Rank Pipeline"
                        tagline = "UMD PhysTwin research | In Development"
                        tech = {["PyTorch", "Open3D", "AnyGrasp", "Qwen3-VL-8B"]}
                        description = {[`- The grasp-ranking pipeline built for my UMD machine learning research on PhysTwin, a physics-based digital twin`,

                                `- Links AnyGrasp-generated grasp visualizations from multi-camera input to reconstructed camera views with Open3D grasp overlays`,

                                `- Feeds those overlays into a PyTorch VLM (Qwen3-VL-8B) to rank and select grasps, with the ability to isolate components during experimentation`,
                            ]}
                        github = "https://github.com/AmarDhillon05/grasp_rank_pipeline"
                    ></Project>

                    <Project
                        align = "right"
                        icon = "trophy"
                        iconBg = "#7e22ce"
                        name = "Echelon"
                        tagline = "A ranking app for competitive events | July 25 - Sep 25"
                        tech = {["React", "Express", "MongoDB", "Pinecone", "Flask", "EC2", "ALB", "ECS", "PyTorch", "Mistral", "LangChain"]}
                        description = {[`- Developed a gamified experience for hosting competitive events used at 10+ local collegiate and high-school hackathons using React, Express, and MongoDB`,

                                `- Built a Mistral-based LangChain pipeline with optimized prompting for faster hackathon search, with deployment as ALB-fronted ECS functions for distributed model functionality on 100+ projects at once deployed as Flask microservices`,
                            ]}
                        github = "https://github.com/AmarDhillon05/echelon"
                        site = "https://echelon-ob8vzl020-amardhillon05s-projects.vercel.app/"
                    ></Project>

                    <Project
                        align = "right"
                        icon = "pin"
                        iconBg = "#990000"
                        name = "PhilaWatch"
                        tagline = "Crime-awareness heatmap · PennApps XXVI | Sep 25"
                        tech = {["React Native", "Google Maps API", "Flask", "Pandas", "Roboflow", "Cerebras"]}
                        description = {[`- Built with a team at PennApps XXVI: a social-sustainability app that maps a year of Philadelphia crime incidents as a heatmap to warn users of risky areas`,

                                `- Generates an AI "danger score" (1-5) for a given place and time using a Cerebras LLM over 100,000+ recent crime entries, plus user-submitted crime-sign reports analyzed by pretrained Roboflow models`,

                                `- React Native frontend with the Google Maps API, backed by Flask + pandas APIs, with a gamified contribution leaderboard to encourage reporting`,
                            ]}
                        github = "https://github.com/aprameyak/PhilaWatch"
                        site = "https://devpost.com/software/crimakopia"
                        media = {[
                            "/project-media/philawatch/1.png",
                            "/project-media/philawatch/2.png",
                            "/project-media/philawatch/3.png",
                            "/project-media/philawatch/4.png",
                            "/project-media/philawatch/5.png",
                        ]}
                    ></Project>

                    <Project
                        align = "right"
                        icon = "piano"
                        iconBg = "#4f46e5"
                        name = "PianoAI"
                        tagline = "A beginner-friendly AI-assisted piano music composer"
                        tech = {["React", "PyTorch", "TorchScript (C++)", "AWS Lambda"]}
                        description = {[`-  Created a beginner-friendly React app containing a simple note composition interface used by myself and friends for teaching basic composition to elementary-school classes`,

                                `- Designed a PyTorch transformer for generating piano notes optimized to use <128 MB during inference on 50+ scores`,

                                `- Utilized TorchScript (C++) on AWS Lambda for JIT model deployment, increasing inference speeds by ~33%`,
                            ]}
                        github = "https://github.com/AmarDhillon05/PianoAI"
                        site = "https://pianoai.adh05.com"
                    ></Project>

                    <Project
                        align = "right"
                        icon = "dollar"
                        iconBg = "#dc2626"
                        name = "$hoes"
                        tagline = "A forecaster for shoe resale prices to aid in smart decisions"
                        tech = {["BeautifulSoup", "Selenium", "Scikit-learn", "React"]}
                        description = {[`- Created web scrapers using BeautifulSoup and Selenium to gather upcoming shoe prices from popular brand sites`,

                                `- Trained a SkLearn regressor on past resell data to predict future resale prices with sub 5$ testing loss to educate resellers`,

                                `- Deployed a React app displaying the results and educating resellers on which shoes are most likely to be good buys`,
                            ]}
                        github = "https://github.com/AmarDhillon05/Shoes"
                        site = "https://shoeapp.adh05.com"
                    ></Project>

                    <Project
                        align = "right"
                        icon = "eye"
                        iconBg = "#db2777"
                        name = "CapNet"
                        tagline = "An original architecture inspired by the Vision Transformer on the CIFAR-100 Dataset"
                        tech = {["PyTorch", "Vision Transformer", "Beam Search"]}
                        description = {[`- Rebuilt and experimented with the Vision Transformer from the original paper`,

                                `- Experimented with using Convolutional attention blocks based on a paper about similar practices`,

                                `- Combined the model with beam search and optimizations to create a fast, efficient captioner`,
                            ]}
                        github = "https://github.com/AmarDhillon05/CapNet"
                        site = "https://www.kaggle.com/code/amardhillon05/vit-experiments-on-cifar-subset"
                    ></Project>

                    <Project
                        align = "right"
                        icon = "food"
                        iconBg = "#ea580c"
                        name = "UVA Meals"
                        tagline = "A simplification of UVA's menu system for HooHacks '25"
                        tech = {["React Native", "Selenium", "MongoDB"]}
                        description = {[`- Created a React Native app to show a simplified version of UVA's menu that was scraped with Selenium`,

                                `- Utilized MongoDB for fast storage and food tracking per day`,

                                `- Created an algorithm for users to have their target nutrition generated from their goals`
                            ]}
                        github = "https://github.com/AmarDhillon05/UVA-Meals"
                        site = "https://devpost.com/software/hoomeals"
                        media = {[
                            "/project-media/uva-meals/1.png",
                            "/project-media/uva-meals/2.png",
                            "/project-media/uva-meals/3.png",
                            "/project-media/uva-meals/4.png",
                        ]}
                    ></Project>

                    <Project
                        align = "right"
                        icon = "rocket"
                        iconBg = "#1d4ed8"
                        name = "NASA Image Repository"
                        tagline = "A simple tool to facilitate the access of NASA's historical info"
                        tech = {["React", "NASA API"]}
                        description = {[`- Created APIs to stream data from NASA's API into interpretable forms`,

                                `- Utilized React to create a UI that allows users to navigate historical entries`
                            ]}
                        github = "https://github.com/AmarDhillon05/Nasa-Image-Lookup"
                    ></Project>

                    <Project
                        align = "right"
                        icon = "camera"
                        iconBg = "#6d28d9"
                        name = "Dorbel"
                        tagline = "An app connected to a security system for recognizing faces at your door"
                        tech = {["Python", "Kivy", "MTCNN", "Raspberry Pi", "MySQL"]}
                        description = {[`- Created a Kivy app in Python for adding faces to be recognized by an algorithm`,

                                `- Used a pretrained MTCNN model on a Raspberry Pi to identify unfamiliar faces on a camera input with little delay`,

                                `- Stored data in MySQL databases for fast and simple user querying`
                            ]}
                        github = "https://github.com/AmarDhillon05/Doorbell-App"
                    ></Project>

                </div>

            </div>
        </div>
    )
}
